import { EarningRuleType } from "./CustomEnums";

export const TIER_TYPE = {
  STARTER: "STARTER",
  GROWTH: "GROWTH",
  PRO: "PRO",
}

export const TIER_TYPE_CONFIG = {
  [TIER_TYPE.STARTER]: {
    // navbar
    segments: false,
    messages: false, // message navbar only show list of message campaigns
    tickets: false,
    languages: false,
    levels: false,
    levelBenefits: false,

    // earning rule type
    [EarningRuleType.generalPurchase]: true,
    [EarningRuleType.qrCodeScanning]: false,
    [EarningRuleType.gpsCheckIn]: false,
    [EarningRuleType.newMember]: false,
    [EarningRuleType.memberReferral]: false,
    [EarningRuleType.birthday]: false,
    [EarningRuleType.levelUpgrade]: false,
    [EarningRuleType.fillingForm]: false,

    // section in earning rule
    targetCustomer: false,
    lineItemGroups: false,

    // online store
    onlineStore: false,
  },
  [TIER_TYPE.GROWTH]: {
    // navbar
    segments: true,
    messages: true,
    tickets: false,
    languages: false,
    levels: false,
    levelBenefits: false,

    // earning rule type
    [EarningRuleType.generalPurchase]: true,
    [EarningRuleType.qrCodeScanning]: true,
    [EarningRuleType.gpsCheckIn]: true,
    [EarningRuleType.newMember]: true,
    [EarningRuleType.memberReferral]: true,
    [EarningRuleType.birthday]: true,
    [EarningRuleType.levelUpgrade]: false,
    [EarningRuleType.fillingForm]: false,

    // section in earning rule
    targetCustomer: false,
    lineItemGroups: false,

    // online store
    onlineStore: true,
  },
  [TIER_TYPE.PRO]: {
    // navbar
    segments: true,
    messages: true,
    tickets: true,
    languages: false,
    levels: false,
    levelBenefits: false,

    // earning rule type
    [EarningRuleType.generalPurchase]: true,
    [EarningRuleType.qrCodeScanning]: true,
    [EarningRuleType.gpsCheckIn]: true,
    [EarningRuleType.newMember]: true,
    [EarningRuleType.memberReferral]: true,
    [EarningRuleType.birthday]: true,
    [EarningRuleType.levelUpgrade]: true,
    [EarningRuleType.fillingForm]: true,

    // section in earning rule
    targetCustomer: true,
    lineItemGroups: true,

    // online store
    onlineStore: true,
  },
};

export const tierType = [
  TIER_TYPE.STARTER,
  TIER_TYPE.GROWTH,
  TIER_TYPE.PRO
].includes(process.env.REACT_APP_TIER_TYPE) ? process.env.REACT_APP_TIER_TYPE : TIER_TYPE.STARTER;

export const tierTypeConfig = TIER_TYPE_CONFIG[tierType];
